import OptionWrapper from "../option-wrapper";

export const SelectableOption = ({ label, selected, onSelect, type = "radio", error }) => {
  return (
    <OptionWrapper selected={selected} error={error} onClick={onSelect} as="button">
      <div className="flex items-center justify-between">
        <span className="text-lg text-text-primary">{label}</span>
        <input type={type} hidden />

        {type === "radio" ? (
          <div
            className={`
              w-5 h-5 rounded-full border-2 flex items-center justify-center
              ${selected ? "border-primary bg-primary" : "border-border bg-background-surface"}
            `}
          >
            {selected && <div className="w-2 h-2 bg-primary-foreground rounded-full" />}
          </div>
        ) : (
          <div
            className={`
              w-5 h-5  border-2 flex items-center justify-center
              ${selected ? "border-primary bg-primary" : "border-border bg-background-surface"}
            `}
          >
            {selected && (
              <svg
                className="w-3 h-3 text-primary-foreground"
                viewBox="0 0 20 20"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
              >
                <polyline points="4 10 8 14 16 6" />
              </svg>
            )}
          </div>
        )}
      </div>
    </OptionWrapper>
  );
};
